import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import axios from 'axios';
import Ajax from '../../utils/ajax';
import styles from './EditorModal.scss';
import Modal from '../../components/Modal/';
import Button from '../../components/Button/Button';
import message from '../../components/Message';
import { getState } from '../../reducers/NoteContent/NoteContentReducer';
import { postAudio, putAudioMessage, deleteAudio, getAudioUrl } from '../../actions/NoteContentAction';

@withRouter
@connect(
  state => ({
    content: getState(state),
  }),
  dispatch => ({
    postAudio: (noteId, audio) => dispatch(postAudio(noteId, audio)),
    putAudioMessage: (noteId, params) => dispatch(putAudioMessage(noteId, params)),
    deleteAudio: noteId => dispatch(deleteAudio(noteId)),
    getAudioUrl: noteId => dispatch(getAudioUrl(noteId)),
  }),
)
export default class EditorAudioModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audioUploadingStatus: this.props.audioMessage.getIn(['title']) === undefined ? 'wait' : 'success',
      uploadingProgress: 0,
      audioName: this.props.audioMessage.getIn(['title']),
      audioAuthor: this.props.audioMessage.getIn(['dubber']),
    };
    this.audioInfo = null;
    this.source = axios.CancelToken.source();
  }

  getAudioInfo = (e) => {
    e.preventDefault();
    e.stopPropagation();
    [this.audioInfo] = e.target.files;
    this.uploadAudio(this.audioInfo);
    this.input.value = '';
  }

  // 获取音频上传策略
  uploadAudio = (audioInfo) => {
    const { match } = this.props;
    const { params: { noteId } } = match;
    const { onModalConfirmBtnClick } = this.props;
    const objectUrl = URL.createObjectURL(audioInfo);
    this.audio.setAttribute('src', objectUrl);
    this.audio.oncanplaythrough = () => {
      const { duration } = this.audio;
      if (audioInfo.size <= 500 * 1000 * 1000) {
        Ajax.getAudioInfo(noteId).then((res) => {
          const { data } = res;
          this.setState({
            audioUploadingStatus: 'uploading',
            audioName: audioInfo.name.slice(0, -4),
            audioAuthor: i18n.get('modal.no-name'),
          });
          const audioPolicy = data;
          const formData = new FormData();
          const type = (audioType) => {
            if (audioType === 'audio/mpeg') {
              return 'mp3';
            } else if (audioType === 'audio/mp3') {
              return 'mp3';
            } else if (audioType === 'audio/x-m4a') {
              return 'm4a';
            }
            return '';
          };
          formData.append('name', `${audioInfo.name}`);
          formData.append('key', `${data.dir}${data.filename}.${type(audioInfo.type)}`);
          formData.append('policy', data.policy);
          formData.append('OSSAccessKeyId', data.access_id);
          formData.append('signature', data.signature);
          formData.append('success_action_status', 200);
          formData.append('callback', data.callback);
          formData.append('x:duration', duration);
          formData.append('x:title', audioInfo.name.slice(0, -4));
          formData.append('x:dubber', i18n.get('modal.no-name'));
          formData.append('file', audioInfo);
          axios({
            url: data.host,
            method: 'post',
            data: formData,
            cancelToken: this.source.token,
            onUploadProgress: (progressEvent) => {
              this.setState({
                uploadingProgress: progressEvent.loaded / progressEvent.total,
              });
            },
          }).then((response) => {
            if (response.status === 200) {
              if (response.data.message === 'OK') {
                const audioMessage = {
                  title: audioInfo.name.slice(0, -4),
                  dubber: i18n.get('modal.no-name'),
                  duration: '',
                  filesize: audioInfo.size,
                  play_url: '',
                };
                this.props.changeAudio();
                this.props.getAudioUrl(noteId);
                this.props.postAudio(noteId, audioMessage);
                this.setState({
                  audioUploadingStatus: 'success',
                  uploadingProgress: 0,
                });
              } else {
                message.error(response.data.error);
                this.setState({
                  audioUploadingStatus: 'failed',
                  uploadingProgress: 0,
                });
              }
            } else {
              message.error(i18n.get('modal.audio-upload-error'));
              this.setState({
                audioUploadingStatus: 'failed',
                uploadingProgress: 0,
              });
            }
          }).catch(() => {
             this.setState({
               audioUploadingStatus: 'failed',
               uploadingProgress: 0,
             });
          });
        }).catch((err) => {
          message.error(i18n.get('modal.audio-upload-error'));
        });
      } else {
        message.error(i18n.get('modal.audio-overlarge'));
      }
    };
  }

  onConfirmBtnClick = (e) => {
    const { audioUploadingStatus, audioName, audioAuthor } = this.state;
    const { match, onModalCancelClick } = this.props;
    const { params: { noteId } } = match;
    const title = (this.audioNameInput.value || this.props.audioMessage.getIn(['title'])).trim();
    const dubber = (this.audioAuthorInput.value || i18n.get('modal.no-name')).trim();
    if (audioUploadingStatus === 'uploading') {
      message.warning(i18n.get('modal.audio-upload-unfinished'));
    } else if (audioUploadingStatus === 'failed') {
      message.warning(i18n.get('modal.audio-uploading-failed'));
      onModalCancelClick();
    } else if (audioName !== this.props.audioMessage.getIn(['title']) || audioAuthor !== this.props.audioMessage.getIn(['dubber'])) {
      this.props.changeAudio();
      this.props.putAudioMessage(noteId, { title, dubber });
      onModalCancelClick();
    } else {
      onModalCancelClick();
    }
  }

  onModalCancel = (e) => {
    const { onModalCancelClick } = this.props;
    const { audioUploadingStatus, audioName, audioAuthor } = this.state;
    if (audioUploadingStatus === 'wait') {
      onModalCancelClick();
    } else if (audioUploadingStatus === 'uploading') {
      message.warning(i18n.get('modal.audio-upload-unfinished'));
    } else if (audioName === this.props.audioMessage.getIn(['title']) && audioAuthor === this.props.audioMessage.getIn(['dubber'])) {
      onModalCancelClick();
    } else {
      Modal.Confirm(`${i18n.get('modal.close-audio-warning')}${i18n.get('modal.close-audio-warning2')}`, {
        onOk: () => {
          onModalCancelClick();
        },
        onCancel: () => {},
      });
    }
  }

  onDeleteAudio = () => {
    const { onModalCancelClick, match } = this.props;
    const { audioUploadingStatus } = this.state;
    const { params: { noteId } } = match;
    Modal.Confirm(`${i18n.get('modal.audio-delete')}`, {
      onOk: () => {
        this.props.changeAudio();
        this.props.deleteAudio(noteId);
        this.setState({
          audioUploadingStatus: 'wait',
        });
      },
      onCancel: () => {},
    });
  }

  onUploadingCancel = () => {
    this.source.cancel();
    this.source = axios.CancelToken.source();
  }

  onAudioNameChange = (e) => {
    this.setState({
      audioName: e.target.value,
    });
  }

  onAudioAuthorChange = (e) => {
    this.setState({
      audioAuthor: e.target.value,
    });
  }

  render() {
    const { visible } = this.props;
    const { audioUploadingStatus, uploadingProgress, audioName, audioAuthor } = this.state;
    const { audioMessage } = this.props;
    const uploadingSuccess = classNames(styles['uploading-status'], {
      [styles['failed']]: audioUploadingStatus === 'failed',
    });
    return (
      <Modal
        width={412}
        visible
        showFooter={false}
        maskClosable={false}
        showMask
        closable
        isMiddle
        onCancel={this.onModalCancel}
      >
        <div className={classNames(styles['kalamu-modal'], styles['kalamu-audio-modal'])}>
          <h3>{i18n.get('modal.insert-audio')}</h3>
          <div className={classNames(styles['modal-body'])}>
            <audio src='' ref={(audio) => { this.audio = audio; }} className={classNames(styles['hidden'])}/>
            <input
              id="kalamu-upload-audio"
              className={classNames(styles['kalamu-upload-audio'])}
              type="file"
              name="file"
              accept="audio/mpeg,audio/x-m4a"
              onChange={this.getAudioInfo}
              ref={(input) => { this.input = input; }}
            />
            {
              audioUploadingStatus === 'wait' &&
              <div className={classNames(styles['tab-panel-url'])}>
                <div className={styles['upload-audio']}>
                  <label htmlFor="kalamu-upload-audio">
                    <i className="fa picture-o"/>
                    {i18n.get('modal.upload-audio')}
                  </label>
                </div>
                <div className={styles['prompt']}>
                  {i18n.get('modal.audio-support', { format: 'MP3/M4A', size: 500 })}
                </div>
              </div>
            }
            {
              audioUploadingStatus !== 'wait' &&
              <div className={classNames(styles['tab-panel-url'])}>
                <div className={classNames(styles['audio-content'])}>
                  {
                    audioUploadingStatus === 'uploading' &&
                    <Fragment>
                      <span className={classNames(styles['uploading-filename-content'])}>
                        <span className={classNames(styles['uploading-filename'])}>{this.audioInfo.name.slice(0, -4)}</span>
                      </span>
                      <span className={classNames(styles['uploading-btn'])} onClick={this.onUploadingCancel}>
                        {i18n.get('modal.audio-cancle')}
                      </span>
                      <span className={classNames(styles['uploading-progress-total'])}>
                        <span className={classNames(styles['uploading-progress-now'])} style={{ width: `${uploadingProgress * 100}%` }}/>
                      </span>
                    </Fragment>
                  }
                  {
                    audioUploadingStatus === 'success' &&
                    <Fragment>
                      <span className={classNames(styles['uploading-status-content'])}>
                        <span className={classNames(styles['uploading-name'])}>{audioMessage.getIn(['title'])}</span>
                        <span className={uploadingSuccess}>{i18n.get('modal.audio-upload-complete')}</span>
                      </span>
                      <span className={classNames(styles['uploading-btn'])}>
                        <label htmlFor="kalamu-upload-audio">
                          {i18n.get('modal.reupload-audio')}
                        </label>
                      </span>
                    </Fragment>
                  }
                  {
                    audioUploadingStatus === 'failed' &&
                    <Fragment>
                      <span className={classNames(styles['uploading-status-content'])}>
                        <span className={classNames(styles['uploading-name'])}>{this.audioInfo.name.slice(0, -4)}</span>
                        <span className={uploadingSuccess}>{i18n.get('modal.audio-upload-failed')}</span>
                      </span>
                      <span className={classNames(styles['uploading-btn'])}>
                        <label htmlFor="kalamu-upload-audio">
                          {i18n.get('modal.retry')}
                        </label>
                      </span>
                    </Fragment>
                  }
                </div>
                <div className={classNames(styles['input-prepend'])}>
                  <b>{i18n.get('modal.audio-name')}</b>
                  <input
                    autoFocus
                    id="audioName"
                    name="audioName"
                    placeholder={i18n.get('modal.insert-audio-name')}
                    type="text"
                    value={audioName}
                    onChange={this.onAudioNameChange}
                    ref={(v) => {
                      this.audioNameInput = v;
                    }}
                  />
                </div>
                <div className={classNames(styles['input-prepend'])}>
                  <b>{i18n.get('modal.audio-author')}</b>
                  <input
                    id="audioAuthor"
                    name="audioAuthor"
                    placeholder={i18n.get('modal.insert-audio-author')}
                    type="text"
                    value={audioAuthor}
                    onChange={this.onAudioAuthorChange}
                    ref={(v) => {
                      this.audioAuthorInput = v;
                    }}
                  />
                </div>
                <div className={styles['btn-wrap']}>
                  <Button type={'primary'} className={styles['btn']} onClick={this.onConfirmBtnClick}>
                    {i18n.get('modal.audio-confirm')}
                  </Button>
                  {
                    audioUploadingStatus !== 'uploading' &&
                    <Button className={styles['delete-btn']} onClick={this.onDeleteAudio}>
                      {i18n.get('modal.delete-audio')}
                    </Button>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorModal/EditorAudioModal.js